import { createStyles } from '@mantine/core'

import { SingleBanner } from '../index.types'

type StyleParams = {
  layout: SingleBanner['layout']
  layoutPosition: SingleBanner['layoutPosition']
}

export default createStyles(
  (theme, { layout, layoutPosition }: StyleParams) => {
    const isFullBanner = layout === 'image_overlay_content'
    return {
      root: {
        position: 'relative',
        backgroundColor: '#fff',
        [theme.fn.smallerThan('sm')]: {
          ...(isFullBanner && {
            height: 0,
            paddingBottom: '133.33%',
          }),
        },
        [theme.fn.largerThan('sm')]: {
          '&:before': {
            content: '""',
            display: 'block',
            height: 0,
            paddingBottom: `${(600 / 1920) * 100}%`,
          },
        },
      },
      inner: {
        [theme.fn.largerThan('sm')]: {
          position: 'absolute',
          inset: 0,
        },
      },
      container: {
        [theme.fn.smallerThan('sm')]: {
          ...((layout === '2_column_layout_1_1' ||
            layout === '2_column_layout_2_1') && {
            '&.hhg-page-container': {
              paddingLeft: 0,
              paddingRight: 0,
            },
          }),
        },
        [theme.fn.largerThan('sm')]: {
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          ...(layoutPosition === 'right_banner' && {
            justifyContent: 'flex-end',
          }),
        },
      },
      info: {
        [theme.fn.smallerThan('sm')]: {
          padding: 24,
          gap: 16,
          ...(isFullBanner && {
            position: 'absolute',
            left: 0,
            right: 0,
            bottom: 0,
          }),
        },
        [theme.fn.largerThan('sm')]: {
          position: 'relative',
          gap: 24,
          order: layoutPosition === 'left_banner' ? 1 : 2,
          width: layout === '2_column_layout_2_1' ? '66.67%' : '50%',
          ...(layoutPosition === 'right_banner' && {
            paddingLeft: 108,
          }),
          ...(isFullBanner && {
            zIndex: 1,
          }),
        },
      },
      picture: {
        [theme.fn.smallerThan('sm')]: {
          ...((layout === '2_column_layout_1_1' ||
            layout === '2_column_layout_2_1') && {
            display: 'block',
            position: 'relative',
            height: 0,
            paddingBottom: '80%',
          }),
          img: {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          },
        },
        [theme.fn.largerThan('sm')]: {
          order: layoutPosition === 'left_banner' ? 2 : 1,
          img: {
            position: 'absolute',
            top: 0,
            left:
              layout === '2_column_layout_2_1'
                ? layoutPosition === 'left_banner'
                  ? '66.67%'
                  : '0'
                : layout === '2_column_layout_1_1'
                ? layoutPosition === 'left_banner'
                  ? '50%'
                  : '0'
                : '0',
            right: 0,
            bottom: 0,
            width:
              layout === '2_column_layout_2_1'
                ? '33.33%'
                : layout === '2_column_layout_1_1'
                ? '50%'
                : '100%',
            height: '100%',
            objectFit: 'cover',
          },
        },
      },
      header: {
        [theme.fn.smallerThan('sm')]: {
          gap: 8,
        },
      },
      actions: {
        display: 'flex',
        gap: 8,
        [theme.fn.smallerThan('sm')]: {
          flexDirection: 'column',
        },
      },
    }
  },
)
